import http from './public'
// 商品列表
export const getAllGoods = (params) => {
  return http.fetchGet('/goods/list', params)
}
// 获取购物车列表
export const getCartList = (params) => {
  return http.fetchPost('/cart/list', params)
}
// 加入购物车
export const addCart = (params) => {
  return http.fetchPost('/cart/add', params)
}
// 删除购物车
export const delCart = (params) => {
  return http.fetchPost('/cart/delete', params)
}
// 编辑购物车
export const updCart = (params) => {
  return http.fetchPost('/cart/update', params)
}
// 全选
export const editCheckAll = (params) => {
  return http.fetchPost('/cart/checkedAll', params)
}
// 获取用户地址
export const addressList = (params) => {
  return http.fetchPost('/address/list', params)
}
// 修改收货地址
export const addressUpdate = (params) => {
  return http.fetchPost('/address/save', params)
}
// 添加收货地址
export const addressAdd = (params) => {
  return http.fetchPost('/address/save', params)
}
// 删除收货地址
export const addressDel = (params) => {
  return http.fetchPost('/address/delete', params)
}
// 取得省
export const provinceList = (params) => {
  return http.fetchPost('/region/provinceList', params)
}
// 取得市
export const cityList = (params) => {
  return http.fetchPost('/region/cityList', params)
}
// 取得区县
export const distinctList = (params) => {
  return http.fetchPost('/region/distinctList', params)
}
// 生成订单
export const submitOrder = (params) => {
  return http.fetchPost('/order/submit', params)
}
// 支付
export const payMent = (params) => {
  return http.fetchPost('/pay/prepay', params)
}
// 支付状态
export const payStatus = (params) => {
  return http.fetchPost('/pay/payStatus', params)
}
// 获取用户订单
export const orderList = (params) => {
  return http.fetchPost('/order/list', params)
}
// 获取单个订单详情
export const getOrderDet = (params) => {
  return http.fetchPost('/order/detail', params)
}
// 取消订单
export const cancelOrder = (params) => {
  return http.fetchPost('/order/cancelOrder', params)
}
// 商品详情
export const productDet = (params) => {
  return http.fetchGet('/goods/detail', params)
}
// 热销商品详情
export const hotGoodsDet = () => {
  return http.fetchGet('/goods/hotGoodsDetail')
}
// 确认收货
export const confirmOrder = (params) => {
  return http.fetchPost('/order/confirmOrder', params)
}
// 商品列表
export const getSearch = (params) => {
  return http.fetchGet('/search/search', params)
}
// 快速搜索
export const getQuickSearch = (params) => {
  return http.fetchGet('/search/quickSearch', params)
}
// 推广列表
export const getAllExtend = (params) => {
  return http.fetchGet('/extension/list', params)
}
// 推广详情
export const extendDet = (params) => {
  return http.fetchPost('/extension/detail', params)
}
// 获取微工厂库存
export const factoryGoodsStock = (params) => {
  return http.fetchPost('/order/factoryGoodsStock', params)
}
// 检查微工厂库存
export const checkFactoryGoodsStock = (params) => {
  return http.fetchPost('/order/checkFactoryGoodsStock', params)
}



// WEBPACK FOOTER //
// ./src/api/goods.js